exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader[data-v-ec40131c]::-webkit-scrollbar{display:none}.truncated[data-v-ec40131c]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
